module.exports = "/_next/static/files/8efd5f68357d3551875a4f53c9ea670e.png";